import {
    Image, Link, TabPanel, Text, VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ComponentProps } from 'react';
import { NonIdealState } from '@acp/core-ui';
import { brandIcons } from '@acp/core-ui/assets';
import { PortfolioFacets } from '@acp/shared';
import { useOverdueInvoices } from './use-overdue-invoices';
import { OverdueInvoiceRow } from './overdue-invoice-row';
import { InvoiceRowLayout } from '../../../invoice';

export function OverdueInvoicesTab({
    propertyManagerId,
    ...props
}: {
    propertyManagerId?: string;
} & ComponentProps<typeof TabPanel>) {
    const invoiceQuery = useOverdueInvoices({
        propertyManagerId,
        uploadingRefetechInterval: 60_000,
    });

    return (
        <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4} {...props}>
            {
                (!invoiceQuery.isLoading && invoiceQuery.data !== undefined)
                && (invoiceQuery.data.total > 0) && (
                    <Text>
                        There are overdue invoices that require your immediate attention
                        as failure to pay may result in suspension of services.
                    </Text>
                )
            }
            <VStack alignItems="center" justifyContent="center" gap={4}>
                {
                    (
                        !invoiceQuery.isLoading
                        && invoiceQuery.data !== undefined
                    )
                    && invoiceQuery.data.items.map((invoice) => (
                        <OverdueInvoiceRow
                            key={invoice.id}
                            invoice={invoice}
                        />
                    ))
                }
                {
                    (
                        !invoiceQuery.isLoading
                        && invoiceQuery.data !== undefined
                        && invoiceQuery.data.items.length === 0
                    )
                    && (
                        <NonIdealState
                            iconComponent={<Image src={brandIcons.noUrgentQuoteInvoice} />}
                            title="No overdue invoices"
                            description="You are all up to date!"
                            py={24}
                        />
                    )
                }
                {
                    invoiceQuery.isLoading
                        && Array.from({ length: 10 }).map((_, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <InvoiceRowLayout.Skeleton key={index} />
                        ))
                }
            </VStack>
            { /** TODO: Change me when the big PR is release for enum facets */}
            {(
                !invoiceQuery.isLoading
                && invoiceQuery.data !== undefined
                && invoiceQuery.data.total > invoiceQuery.data.items.length
                && propertyManagerId === undefined
            ) && (
                <Link as={RouterLink} to={`/portfolio?facet=${PortfolioFacets.OverdueInvoices}`}>
                    View all overdue invoices
                </Link>
            )}
            {(
                !invoiceQuery.isLoading
                && invoiceQuery.data !== undefined
                && invoiceQuery.data.total > invoiceQuery.data.items.length
                && propertyManagerId !== undefined
            ) && (
                <Link as={RouterLink} to={`/portfolio?facet=${PortfolioFacets.OverdueInvoices}&property-manager=${propertyManagerId}`}>
                    View all overdue invoices
                </Link>
            )}
        </TabPanel>
    );
}
